import { handleRequest } from '_services';

export const scanService = {
    raw
};

async function raw(scanId) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/scan/raw?scanId=' + scanId, requestOptions, true, false);
};
